import { defineNuxtPlugin } from '#app/nuxt'
import { LazyGlobalAlertNotification, LazyGlobalEnvTag, LazyGlobalPageBanner, LazyGlobalPageBannerContent, LazySiteVersionCheck } from '#components'
const lazyGlobalComponents = [
  ["GlobalAlertNotification", LazyGlobalAlertNotification],
["GlobalEnvTag", LazyGlobalEnvTag],
["GlobalPageBanner", LazyGlobalPageBanner],
["GlobalPageBannerContent", LazyGlobalPageBannerContent],
["SiteVersionCheck", LazySiteVersionCheck],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
